import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { Constants } from '../../utils/constants';
import { alpha, styled, useColorScheme } from '@mui/material/styles';

export default function MainDateRangePicker(props) {
    const { value, onChange } = props;
    const { mode } = useColorScheme();
    const currentMode = mode || "light";

    const DateRangePickerWrapper = styled('div')(({ theme }) => ({
        '& .react-daterange-picker__wrapper': {
            width: "100%",
            minWidth: "260px",
            borderRadius: Constants.Styles.radius.base,
            backgroundColor: "transparent",
            color: Constants.Colors[currentMode].foreground,
            border: `1px solid ${Constants.Colors[currentMode].border}`,
            padding: "4px",
            fontSize: Constants.Styles.fontSize.sm,
            fontWeight: Constants.Styles.fontWeight.medium,
            "&:hover": {
                borderColor: "transparent",
                backgroundColor: Constants.Colors[currentMode].accent,
                color: alpha(Constants.Colors[currentMode].accentForeground, 1),
                '& .react-daterange-picker__inputGroup__input': {
                    color: Constants.Colors[currentMode].accentForeground,
                },
                '& .react-daterange-picker__inputGroup__divider': {
                    color: Constants.Colors[currentMode].accentForeground,
                },
                '& .react-daterange-picker__clear-button__icon': {
                    stroke: Constants.Colors[currentMode].accentForeground,
                },
                '& .react-daterange-picker__calendar-button__icon': {
                    stroke: Constants.Colors[currentMode].accentForeground,
                }
            }
        },
        '& .react-daterange-picker__inputGroup__input': {
            color: Constants.Colors[currentMode].foreground,
        },
        '& .react-daterange-picker__inputGroup__divider': {
            color: Constants.Colors[currentMode].foreground,
        },
        '& .react-daterange-picker__clear-button__icon': {
            stroke: Constants.Colors[currentMode].foreground,
        },
        '& .react-daterange-picker__calendar-button__icon': {
            stroke: Constants.Colors[currentMode].foreground,
        },
        '& .react-daterange-picker__calendar': {
            zIndex: 50,
        },
        '& .react-calendar': {
            width: '350px',
            maxWidth: '100%',
            backgroundColor: Constants.Colors[currentMode].background,
            color: Constants.Colors[currentMode].foreground,
            borderRadius: Constants.Styles.radius.base,
            border: `1px solid ${Constants.Colors[currentMode].border}`,
            fontFamily: "inherit",
            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
        },
        '& .react-calendar__navigation': {
            display: 'flex',
            height: '44px',
            marginBottom: '1em',
        },
        '& .react-calendar__navigation button': {
            minWidth: '44px',
            background: 'none',
            color: Constants.Colors[currentMode].foreground,
            fontSize: Constants.Styles.fontSize.base,
        },
        '& .react-calendar__navigation button:disabled': {
            backgroundColor: Constants.Colors[currentMode].muted,
        },
        '& .react-calendar__navigation button:enabled:hover, & .react-calendar__navigation button:enabled:focus': {
            backgroundColor: Constants.Colors[currentMode].muted,
            // borderRadius: Constants.Styles.radius.base,
        },
        '& .react-calendar__month-view__weekdays': {
            textAlign: 'center',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            fontSize: '0.75em',
            color: Constants.Colors[currentMode].mutedForeground,
        },
        '& .react-calendar__month-view__weekdays__weekday': {
            padding: '0.5em',
        },
        '& .react-calendar__month-view__days__day--weekend': {
            color: Constants.Colors[currentMode].destructive,
        },
        '& .react-calendar__tile': {
            maxWidth: '100%',
            padding: '10px 6.6667px',
            background: 'none',
            textAlign: 'center',
            lineHeight: '16px',
            fontSize: Constants.Styles.fontSize.sm,
            color: Constants.Colors[currentMode].foreground,
            // borderRadius: Constants.Styles.radius.base,
        },
        '& .react-calendar__tile:disabled': {
            backgroundColor: Constants.Colors[currentMode].muted,
            color: Constants.Colors[currentMode].mutedForeground,
        },
        '& .react-calendar__tile:enabled:hover, & .react-calendar__tile:enabled:focus': {
            backgroundColor: Constants.Colors[currentMode].muted,
        },
        '& .react-calendar__tile--now': {
            background: Constants.Colors[currentMode].secondary,
            color: Constants.Colors[currentMode].secondaryForeground,
        },
        '& .react-calendar__tile--now:enabled:hover, & .react-calendar__tile--now:enabled:focus': {
            background: Constants.Colors[currentMode].secondary,
        },
        '& .react-calendar__tile--hasActive': {
            background: Constants.Colors[currentMode].accent,
            color: Constants.Colors[currentMode].primaryForeground,
        },
        '& .react-calendar__tile--hasActive:enabled:hover, & .react-calendar__tile--hasActive:enabled:focus': {
            background: Constants.Colors[currentMode].accent,
        },
        '& .react-calendar__tile--active': {
            background: Constants.Colors[currentMode].accent,
            color: Constants.Colors[currentMode].accentForeground,
        },
        '& .react-calendar__tile--active:enabled:hover, & .react-calendar__tile--active:enabled:focus': {
            background: Constants.Colors[currentMode].accent,
        }
    }));
    return (
        <DateRangePickerWrapper>
            <DateRangePicker
                onChange={onChange}
                value={value}
            />
        </DateRangePickerWrapper>
    );
};